import React from 'react';
import { AmountFormat } from '../../../lib/helper/amountFormat';

const DiscountInput = ({
    discountType = 'percentage',
    discountValue = '',
    onDiscountTypeChange,
    onDiscountValueChange,
    currency = 'USD',
    discountAmount = 0,
    onRemove,
}) => {
    return (
        <div className="w-full rounded-xl border border-dashed border-orange-300 bg-orange-50/50 p-3 my-3">
            <p className="text-xs font-semibold text-orange-700 mb-2">Discount</p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                {/* Toggle buttons */}
                <div className="flex rounded-lg border border-gray-200 overflow-hidden shrink-0">
                    <button
                        type="button"
                        onClick={() => {
                            onDiscountTypeChange('percentage');
                            onDiscountValueChange('');
                        }}
                        className={`px-3 py-1.5 text-xs font-medium transition-all duration-200 ${
                            discountType === 'percentage'
                                ? 'bg-orange-500 text-white shadow-sm'
                                : 'bg-white text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                        % Percentage
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            onDiscountTypeChange('value');
                            onDiscountValueChange('');
                        }}
                        className={`px-3 py-1.5 text-xs font-medium transition-all duration-200 ${
                            discountType === 'value'
                                ? 'bg-orange-500 text-white shadow-sm'
                                : 'bg-white text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                        {currency} Fixed
                    </button>
                </div>

                {/* Input group: prefix box + input field */}
                <div className="relative flex-1 flex rounded-lg border border-gray-200 overflow-hidden focus-within:border-orange-400 focus-within:ring-1 focus-within:ring-orange-200 transition-all bg-white">
                    <span className="flex items-center px-2.5 bg-gray-50 border-r border-gray-200 text-gray-500 text-xs font-medium select-none shrink-0">
                        {discountType === 'percentage' ? '%' : currency}
                    </span>
                    <input
                        type="number"
                        min="0"
                        max={discountType === 'percentage' ? 100 : undefined}
                        step="0.01"
                        value={typeof discountValue === 'number' && discountValue === 0 ? '' : discountValue}
                        onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '' || raw === null) {
                                onDiscountValueChange('');
                                return;
                            }
                            const num = parseFloat(raw);
                            if (isNaN(num) || num < 0) return;
                            if (discountType === 'percentage' && num > 100) return;
                            onDiscountValueChange(raw);
                        }}
                        onKeyDown={(e) => {
                            if (['-', '+', 'e', 'E'].includes(e.key)) e.preventDefault();
                        }}
                        onWheel={(e) => e.target.blur()}
                        placeholder={discountType === 'percentage' ? 'e.g. 10' : 'e.g. 200'}
                        className="flex-1 px-2.5 py-1.5 text-xs outline-none bg-transparent"
                    />
                </div>

                {/* Live badge */}
                {(discountAmount > 0 || (discountValue !== '' && Number(discountValue) > 0)) && (
                    <div className="flex items-center gap-2 shrink-0">
                        {discountAmount > 0 && (
                            <span className="shrink-0 text-xs font-semibold text-green-600">
                                - {AmountFormat(discountAmount, currency)}
                            </span>
                        )}
                        {onRemove && (
                            <button
                                type="button"
                                onClick={onRemove}
                                className="px-2 py-1 text-xs font-medium text-red-600 hover:text-red-700 bg-red-50 hover:bg-red-100 rounded border border-red-200 transition-colors duration-150 cursor-pointer"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                )}
            </div>

            <p className="text-[11px] text-gray-500 mt-2 leading-relaxed">
                Note: Discount applies exclusively to base service charges. Customs duties, VAT, and statutory taxes are excluded.
            </p>
        </div>
    );
};

export default DiscountInput;
